import { IProblem } from "./IProblem";

export class problem_api {

    public static get_machine_status:string = "/api/problem/get_machine_status"
    public static get_problems_short:string = "/api/problem/get_problems_short"
    public static create:string = "/api/problem/create"
    public static find_by_id:string = "/api/problem/find_by_id"
    public static update:string = "/api/problem/update"
    public static delete:string = "/api/problem/delete"
    
}

export interface IProblemSvc {
    get_machine_status(): Promise<IProblem[] | undefined> 
    get_problems_short(device_id:any, limit:number): Promise<IProblem[] | undefined> 
    find_by_id(_id: any): Promise<IProblem | undefined> 
    create(device_id:any, user:string) : Promise<IProblem | undefined>  
    update(problem:IProblem): Promise<IProblem | undefined> 
    delete(problem:IProblem): Promise<IProblem | undefined> 
}